require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-financial-center-donates-usd-5-000-to-st-vincent-de-paul-food-pantry.json") })
        }
      }, "path---es-articles-financial-center-donates-usd-5-000-to-st-vincent-de-paul-food-pantry");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-financial-center-donates-usd-5-000-to-st-vincent-de-paul-food-pantry!./.cache/json/es-articles-financial-center-donates-usd-5-000-to-st-vincent-de-paul-food-pantry.json
// module id = 2115
// module chunks = 231608221292675